const ProfileForms = (function ProfileForms() {
	const form = document.querySelector('.user-profile .cmpt-form-wrapper');

	class ValidationError {
		constructor(message) {
			const error = document.createElement('div');
			error.classList.add('field-validation-error');
			error.innerHTML = message;
			return error;
		}
	}

	function isValidEmail(email) {
		var validEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-]+$/;
		return validEmail.test(email);
	}

	function isValidDate(date) {
		var validDate = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])$/;
		return validDate.test(date);
	}

	function isValidMobile(mobile) {
		var validMobile = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/;
		return validMobile.test(mobile);
	}

	function attachEvents() {
		form.addEventListener('submit', function (e) {
			const existingErrors = form.querySelectorAll('.field-validation-error');
			existingErrors.forEach(error => error.remove());
			let inputs = form.getElementsByTagName('input');

			for (let input of inputs) {
				if (input.id === 'email' && !isValidEmail(input.value) && input.value !== '') {
					e.preventDefault();
					const validationError = new ValidationError('Please enter a valid email.');
					input.parentNode.appendChild(validationError);
				}

				if (input.id === 'birthday' && !isValidDate(input.value) && input.value !== '') {
					e.preventDefault();
					const validationError = new ValidationError('Enter birthday in the following format (MM/DD)');
					input.parentNode.appendChild(validationError);
				}
				if (input.id === 'mobile-number' && !isValidMobile(input.value) && input.value !== '') {
					e.preventDefault();
					const validationError = new ValidationError('Please enter a valid phone number');
					input.parentNode.appendChild(validationError);
				}

				if (input.value === '' && input.required) {
					e.preventDefault();
					const validationError = new ValidationError('This is a required field');
					input.parentNode.appendChild(validationError);
				}
			}
		});

		form.addEventListener('input', function (e) {
			const field = e.target;
			const error = field.parentNode.querySelector('.field-validation-error');
			if (error) {
				error.remove();
			}
		})
	}

	function init() {
		if (!form) {
			return;
		}
		attachEvents();
	}

	init();
}());
